import PropTypes from 'prop-types';

export const formatFunctionPropTypes = {
  formatMessage: PropTypes.func.isRequired,
  formatHTMLMessage: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired,
  formatDateTime: PropTypes.func.isRequired,
  formatRelative: PropTypes.func.isRequired
};
